import React from 'react';
import { SidebarOption } from './types';
import './Sidebar.scss';
import { useAppSelector } from '../../hooks/storeHooks';

interface SidebarProps {
  selectedOption: SidebarOption | null;
  onOptionClick: (option: SidebarOption) => void;
  options?: SidebarOption[]; // optional override
}

const Sidebar: React.FC<SidebarProps> = ({ selectedOption, onOptionClick, options }) => {
  const chartType = useAppSelector((state) => state.AssetAnalysis.chartType);

  const baseSidebarOptions: SidebarOption[] = [
    '24 hours',
    '7 days',
    '14 days',
    '30 days',
    '90 days',
    'six months',
    '1 year',
  ];

  const additionalSidebarOptions: SidebarOption[] = ['POP', 'Current compl.'];

  const computed =
    chartType === 'rl-well-charts' ? baseSidebarOptions : [...baseSidebarOptions, ...additionalSidebarOptions];

  const sidebarOptions = Array.isArray(options) && options.length ? options : computed;

  return (
    <nav className='sidebar'>
      {sidebarOptions.map((option) => (
        <button
          analytics-id='sidebar-option-btn'
          key={option}
          type='button'
          className={`sidebar-option ${selectedOption === option ? 'selected-primary' : ''}`}
          onClick={() => onOptionClick(option)}
        >
          <span className='option-text'>{option}</span>
        </button>
      ))}
    </nav>
  );
};

export default Sidebar;
